import React, { Component } from "react"
import Helmet from "react-helmet"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import get from 'lodash/get'

import TopNav from "../components/TopNav"
import Carousel from "../components/Carousel"

/*
**
** this is used for pre-generating pages
**
*/

class PageTemplate extends Component {
  imgdir() {
    const site = get(this, 'props.data.site.siteMetadata')
    return `${get(site, 'url')}/img`
  }

  logo() {
    const site = get(this, 'props.data.site.siteMetadata')
    return `${get(site, 'url')}/img/logo/logo-lang.png`
  }

  footerlogo() {
    const site = get(this, 'props.data.site.siteMetadata')
    return `${get(site, 'url')}/img/logo/logo-cirkel.png`
  }

  footer() {
    const siteMetadata = this.props.data.site.siteMetadata

    return (
      <footer className="mt-5">
        <div className="separator separator-primary px-0 mx-0"></div>

        <div className="container-fluid container-footer">

          <div className="row row-bg-light">
            <div className="col-md-4 py-5 text-center">
              <h3 className="text-uppercase">In welke regio's zijn we actief?</h3>
              <p className="mb-0 px-5">Grondwerken Dierckx is gevestigd in Kasterlee.</p>
              <p className="px-5">Dit houdt in dat wij voornamelijk in de Kempen werken (Kasterlee, Geel, Turnhout, Retie, Arendonk, Dessel, Mol, Olen, Herentals).</p>
              <p className="mb-0 px-5">Mail of bel ons gerust voor meer toelichting, of een prijsinschatting! We helpen je graag!</p>
            </div>
            <div className="col-md-8 px-0" data-key="AIzaSyBkoLitK8BQus20kLAPang_udxMcf1mekU">
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                src="https://www.google.com/maps/embed/v1/search?key=AIzaSyBkoLitK8BQus20kLAPang_udxMcf1mekU&q=Grootrees+58+2460+Kasterlee">
              </iframe>
            </div>
          </div>

          <div className="row pt-5">|
            <div className="col-12 col-md-4">
              <div className="row">
                <div className="col-md-3 pt-2"></div>
                <div className="col-md-9">
                  <h3 className="h4 d-inline-block text-uppercase text-underline">Over ons</h3>
                  <p className="text-uppercase">{siteMetadata.legalName}<br />{siteMetadata.VATnr}</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="row">
                <div className="col-md-3 pt-2"></div>
                <div className="col-md-9">
                  <h3 className="h4 d-inline-block text-uppercase text-underline">Adres</h3>
                  <p className="text-uppercase">{siteMetadata.address1}<br />{siteMetadata.address2}</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="row">
                <div className="col-md-3 pt-2"></div>
                <div className="col-md-9">
                  <h3 className="h4 d-inline-block text-uppercase text-underline">Contact</h3>
                  <p className="text-uppercase">
                    <a href={`tel: ${siteMetadata.mobileNr.raw}`} className="">{siteMetadata.mobileNr.formatted}</a>
                    <br />
                    <a href={`mailto:${siteMetadata.email}`} className="">{siteMetadata.email}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-footer-legal">
            <div className="col-12">
              <p className="text-muted text-center">
                &copy; 2018 grondwerkendierckx.be | design by <a href="https://www.detalje.be" target="_blank">detalje</a>
              </p>
            </div>
          </div>
          <img src={this.footerlogo()} height="125px" alt={siteMetadata.title} className="footerlogo" />
        </div>
      </footer>
    )
  }

  render() {
    const siteMetadata = this.props.data.site.siteMetadata
    const current = this.props.data.wordpressWpRealisations
    const menuItems = this.props.data.wordpressWpApiMenusMenusItems.items

    let content = (
      <div>
        <main role="main" className="">
          <div className="container mt-5">
            <div className="row mb-4">
              <small>
                <Link to={`../`}>&laquo; terug</Link>
              </small>
            </div>

            <div className="row">
              <div className="col-12">
                <h1 className="" dangerouslySetInnerHTML={{ __html: current.title }}></h1>
                <h2 className="h3">{current.acf.location}</h2>
                <h3 className="h4">{current.acf.postcode}</h3>
              </div>
              <div className="col-12 col-md-6">
                <Carousel images={current.acf.realisation_photos_before[0]}></Carousel>
              </div>
              <div className="col-12 col-md-6">
                <Carousel images={current.acf.realisation_photos_after[0]}></Carousel>
              </div>
              <div className="col-12 mt-4">
                <div className="card">
                  <div className="card-body" dangerouslySetInnerHTML={{ __html: current.content }}>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    )

    return (
      <div className="page">
        <Helmet bodyAttributes={{ class: 'navbar-fixed-top' }} htmlAttributes={[{ lang: 'nl' }]}>
          <meta name="referrer" content="origin" />
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>{`${current.title} | ${siteMetadata.title}`}</title>
          <meta name="description" content={`${siteMetadata.description}`} />
          <link rel='canonical' href={`${siteMetadata.url}${this.props.location.pathname}/`} />
        </Helmet>
        <TopNav items={menuItems} location={this.props.location.pathname} logo={this.logo()} siteUrl={siteMetadata.url}></TopNav>
        {content}
        {this.footer()}
      </div>
    )
  }
}

export default PageTemplate

export const pageQuery = graphql`
  query currentRealisationQuery($id: String!) {
    wordpressWpRealisations(id: { eq: $id }) {
      id
      wordpress_id
      slug
      title
      content
      link
      acf {
        realisation_photos_before {
          imageURL
          thumbURL
        }
        realisation_photos_after {
          imageURL
          thumbURL
        }
        postcode
        location
      }
    }
    wordpressWpApiMenusMenusItems(slug: { eq: "topnav"}) {
      wordpress_id
      name
      slug
      items {
        wordpress_id
        title
        url
        order
        object_slug
      }
    }
    site {
      id
      siteMetadata {
        title
        description
        url: siteUrl
        VATnr
        legalName
        address1
        address2
        mobileNr {
          formatted
          raw
        }
        email
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/realisation.js